/**
 * BookingWizardProgress — Phase 3 §4 mid-nav progress indicator.
 *
 * Renders inside CustomerTopNav when a `<BookingWizardProvider>` is
 * mounted (i.e., the user is mid-`/book` flow). Replaces the 4
 * NavLinks with a 4-segment horizontal bar matching the look of
 * `<StepDots>` inside the wizard body + a small "Step N of 4" label.
 *
 * Logo + Book a Pluck CTA + AvatarDropdown stay visible around this
 * component per spec (K11).
 */
import React from "react";
import { cn } from "@/lib/utils";

export default function BookingWizardProgress({ step, totalSteps = 4 }) {
  const segments = Array.from({ length: totalSteps }, (_, i) => i + 1);
  return (
    <div
      className="flex items-center gap-3 w-full max-w-[420px]"
      data-testid="booking-wizard-progress"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-valuenow={step}
      aria-label={`Booking wizard — step ${step} of ${totalSteps}`}
    >
      <div className="flex flex-1 gap-1.5">
        {segments.map((i) => (
          <div
            key={i}
            className={cn(
              "h-1.5 flex-1 rounded-full transition-colors",
              i <= step ? "bg-pp-orange" : "bg-pp-line"
            )}
            data-testid={`booking-wizard-progress-segment-${i}`}
            data-active={i <= step || undefined}
          />
        ))}
      </div>
      <span
        className="shrink-0 text-[12px] font-bold uppercase tracking-[0.08em] text-pp-text-soft"
        data-testid="booking-wizard-progress-label"
      >
        Step {step} of {totalSteps}
      </span>
    </div>
  );
}
